import { render, staticRenderFns } from "./heBangDialog.vue?vue&type=template&id=0bbf5843&scoped=true&"
import script from "./heBangDialog.vue?vue&type=script&lang=js&"
export * from "./heBangDialog.vue?vue&type=script&lang=js&"
import style0 from "./heBangDialog.vue?vue&type=style&index=0&id=0bbf5843&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf5843",
  null
  
)

export default component.exports